/* eslint-disable no-template-curly-in-string */
import { once } from 'ramda';

import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL } from './utils';

const ID = '62';
const IABids = [686, 128, 129];

export const createPixel = (): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  const redirection = `${getUserSyncURL(ID)}${encodeURIComponent(
    '${BSW_UUID}&cookie_age=${COOKIE_AGE}',
  )}`;
  iframe.src = `https://x.bidswitch.net/check_uuid/${redirection}`;

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABids, () => {
    const iframe = createPixel();

    fastdom.mutate(function userSyncMediagridAddElement() {
      document.body.appendChild(iframe);
    });
  }),
);
